import { callDeepLink, toQueryString } from '@croquiscom/web2app';

import {
  useCatalogProductIdParams,
  useGetPdpIntegratedData,
  usePdpBaseInfo,
  usePdpConfig,
  useTabReplacer,
} from '@domains/pdp-common';

export function ReviewSummaryService() {
  const { isZigzagApp } = usePdpConfig();
  const { replaceTab } = useTabReplacer();
  const { catalog_product_id } = useCatalogProductIdParams();
  const { product, shop, flags } = usePdpBaseInfo({ catalog_product_id });
  const { related_product_review_summary, ux_review_list } = useGetPdpIntegratedData({
    catalog_product_id: product.id,
  });

  const reviewConfig = isZigzagApp
    ? {
        path: {
          review: {
            list: (review_id: string) => {
              const query = toQueryString({
                product_id: product.id,
                review_id,
                attachment_position: 0,
              });
              return `/photo_review?${query}`;
            },
          },
        },
        replaceReviewTab: () =>
          callDeepLink('/browser_product_review')({
            shop_main_domain: shop.main_domain,
            product_id: product.id,
          }),
      }
    : {
        path: { review: { list: (product_id: string) => `/review/list/${product_id}` } },
        replaceReviewTab: () => replaceTab('REVIEW'),
      };
  const isHide = !flags?.show_review_summary_best_carousel;

  return {
    ...reviewConfig,
    isZigzagApp,
    catalog_product_id: product.id,
    related_product_review_summary,
    ux_review_list,
    isHide,
  };
}
